export const getTokenLocalStorageKey = (appId: string): string => `app_${appId}_token`;
export const REFERRER_LOCAL_STORAGE = 'gamix_referrer';

export const REFERRAL_QUERY_PARAMS = {
  GAMIPHY_APP_ID: 'gamiphy_app_id',
  GAMIPHY_USER_ID: 'gamiphy_user_id',
};

export enum WsEvents {
  userUpdated = 'user.updated',
}
